import {Component, inject, OnInit} from '@angular/core';
import {BulkActionService} from "../../../service/bulk.action.service";
import {BulkAction} from "../../../model/bulk/bulkAction";
import {HttpErrorResponse} from "@angular/common/http";
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef,
  MatTable, MatTableDataSource
} from "@angular/material/table";
import {FormBuilder, FormControl, ReactiveFormsModule} from "@angular/forms";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {BulkActionCreateComponent} from "../bulk-action-create/bulk-action-create.component";
import {NgClass} from "@angular/common";
import {debounceTime, Observable} from "rxjs";

@Component({
  selector: 'app-bulk-actions',
  standalone: true,
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCellDef,
    MatCell,
    MatHeaderRow,
    MatRow,
    MatHeaderRowDef,
    MatRowDef,
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './bulk-actions.component.html',
  styleUrl: './bulk-actions.component.css'
})
export class BulkActionsComponent implements OnInit {

  private readonly FORM_WIDTH = '60%';

  private bulkActionService = inject(BulkActionService);
  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private dialog = inject(MatDialog);

  bulkActions: BulkAction[] = [];
  error = "";

  dataSource = new MatTableDataSource<BulkAction>(this.bulkActions);
  displayedColumns = ['bulkActionId', 'name', 'bulkActionType', 'bulkActionStatus',
    'creatorEmail', 'createdDateTime'];

  filterForm = this.createFilterForm();

  private createFilterForm() {
    const form = this.formBuilder.group({
      imei: new FormControl(null)
    });

    form.valueChanges.pipe(debounceTime(500)).subscribe((changes) => {
      this.getBulkActions(changes.imei ? changes.imei : null);
    });

    return form;
  }

  goToBulkAction(bulkAction: BulkAction) {
    void this.router.navigate(['bulk-actions/' + bulkAction.bulkActionId]);
  }

  createBulkAction() {
    const dialogRef = this.dialog.open(BulkActionCreateComponent, {
      width: this.FORM_WIDTH
    });

    dialogRef.afterClosed().subscribe(() => this.getBulkActions(null));
  }

  private getBulkActions(imei: string | null) {
    if (imei) {
      this.processResponse(this.bulkActionService.findByImei(imei));
    } else {
      this.processResponse(this.bulkActionService.getAll());
    }
  }

  private processResponse(observable: Observable<BulkAction[]>) {
    return observable.subscribe({
      next: response => {
        this.bulkActions = response;
        this.dataSource = new MatTableDataSource<BulkAction>(this.bulkActions);
      },
      error: err => {
        if (err instanceof HttpErrorResponse) {
          console.log("unable to retrieve bulk actions: " + err.status + " " + err.message);
          this.error = err.message;
        }
      }
    });
  }

  ngOnInit() {
    this.getBulkActions(null);
  }
}
